/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
//actions
import { setAuthData } from 'state/actions/session_status';
import { setFormEditableState, resetForm, receiveFormData } from 'state/actions/shared_form_actions';
import { updateUserInfoWithValidation } from 'state/actions/profile_status';
import MyProfile from 'pages/dashboard/myprofile/myprofile';



/* ========== ~~~~~~~~~~ BUTTON : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ profileStatus, sessionStatus }) => ({
    fields: profileStatus.personalInformationForm.fields,
    savingData: profileStatus.personalInformationForm.savingData,
    editable: profileStatus.personalInformationForm.editable,
    hasStoredData: Object.keys(profileStatus.personalInformationForm.storedData).length > 0,
    mocked: sessionStatus.mocked,
    userEmail: sessionStatus.userEmail,
    userFirstName: sessionStatus.userFirstName,
    userLastName: sessionStatus.userLastName,
    userPhoneNumber: sessionStatus.userPhoneNumber,
    userUUID: sessionStatus.userUUID
});

// map actions
const mapDispatchToProps = dispatch => ({
    setFormEditableState: (formName, isEditable) => dispatch(setFormEditableState(formName, isEditable)),
    updateUserInfoWithValidation: (fields, updatedFormData, userUUID, onSuccess, onFail) => dispatch(updateUserInfoWithValidation(fields, updatedFormData, userUUID, onSuccess, onFail)),
    resetForm: formName => dispatch(resetForm(formName)),
    receiveFormData: (formName, formData) => dispatch(receiveFormData(formName, formData)),
    setAuthData: data => dispatch(setAuthData(data))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyProfile);